module.exports = __webpack_public_path__ + "static/img/02.dad52490.jpg";